/* istanbul ignore file */ /* eslint-disable @typescript-eslint/no-namespace */ (function(BusinessTelemetry) {
    (function(dataBi) {
        dataBi["sortingDropdownId"] = "sortByDropdown";
        dataBi["sortingDropdownName"] = "Sorting dropdown";
    })(BusinessTelemetry.dataBi || (BusinessTelemetry.dataBi = {}));
    (function(Filters) {
        Filters["Activating"] = "Activating";
        Filters["Deactivating"] = "Deactivating";
        Filters["FiltersCleared"] = "Filters cleared";
    })(BusinessTelemetry.Filters || (BusinessTelemetry.Filters = {}));
    (function(ProductAvailabilityType) {
        ProductAvailabilityType["Private"] = "private";
        ProductAvailabilityType["Public"] = "public";
    })(BusinessTelemetry.ProductAvailabilityType || (BusinessTelemetry.ProductAvailabilityType = {}));
})(BusinessTelemetry || (BusinessTelemetry = {}));
export var BusinessTelemetry;
